import { Button, Input, Select, Spin, Table, Tag } from "antd";
import PageHeader from "../../components/PageHeader";
import { AuthService } from "../../services/AuthService";
import { useContext, useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { ORDER_STATUS } from "../../constants";
import Title from "antd/es/typography/Title";
import { CloseOutlined } from "@ant-design/icons";
import { UserContext } from "../../context/userContext";

const columns = [
    {
        title: "ID",
        dataIndex: "id",
        key: "id",
    },
    {
        title: "Emri",
        dataIndex: "fullName",
        key: "fullName"
    },
    {
        title: "Data",
        dataIndex: "orderDate",
        key: "orderDate"
    },
    {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (status) => {
            switch (status) {
                case 'Processing':
                    return <Tag color="processing">Processing</Tag>;
                case 'Delivered':
                    return <Tag color="success">Delivered</Tag>;
                // Add more cases for different statuses if needed
                case "Pending":
                    return <Tag color="orange">Pending</Tag>
                default:
                    return <Tag>{status}</Tag>;
            }
        },
    },
    {
        title: "Total",
        dataIndex: "total",
        key: "total"
    }
]

const Orders = () => {

    const {user} = useContext(UserContext);
    const [selectedUser, setSelectedUser] = useState(null);
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);

    const [users, setUsers] = useState([]);

    const getOrders = async (user = null) => {
        setLoading(true);
        let res = user ? await AuthService.getOrdersByUser(user) : await AuthService.getAllOrders({});
        console.log("get all orders", res);
        if (res && res.length > 0) {
            let formatted = res.map(el => {
                let upEl = { ...el };
                upEl.orderDate = moment(upEl?.orderDate).format("DD.MM.YYYY");
                
                if (!upEl.status) {
                    upEl.status = ORDER_STATUS[0];
                }
                else {
                    upEl.status = ORDER_STATUS[upEl.status]
                }
                console.log("disck", upEl.totalDiscount)
                if(upEl?.totalDiscount > 0){
                
                    upEl.total = Number(upEl.totalAmount) - Number(upEl.totalDiscount);
                }
                else{
                    upEl.total = upEl.totalAmount
                }
                
                upEl.total = upEl.total + "€"
                return upEl;
            })
            setOrders(formatted);
        }
        else{
            setOrders([])
        }
        setLoading(false);
    }

   

    const renderStatus = (status) => {
        switch (status) {
            case "Processing":
                return <Tag color="orange">Processing</Tag>;
            // Add more cases as needed
            default:
                return <Tag>{status}</Tag>;
        }
    }

    const handleRowClick = (record) => {
        navigate("/orders/view", { state: { order: record } });
    }

    const getAllUsers = async () => {
        setLoading(true);
        let res = await AuthService.getAllUsers({});
        if (res) {
           
            setUsers(res);
        }
        console.log("get all users", res);
        setLoading(false);
    }


    useEffect(() => {
        
        
       
        if(user?.details?.roleName == "User"){
            getOrders(user?.details?.id)
        }
        else{
            getOrders(null);
            getAllUsers();
        }
    }, [])

    useEffect(()=>{
        if(selectedUser){
            getOrders(selectedUser)
        }
    }, [selectedUser])

    return (
        <div className="container">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <Title level={4} style={{ fontWeight: '400', fontFamily: 'Source Sans 3' }}>Porosite</Title>

            </div>
            <div className="d-flex justify-content-end align-items-center">
                <div className="d-flex justify-content-start">
                    {user?.details?.roleName !== "User" && (
                        <>
                        <Select
                            labelInValue
                            placeholder="Zgjedh perdoruesin"
                            value={selectedUser}
                            style={{ width: "100%", minWidth: 200 }}
                            onChange={(e: any) => {
                                setSelectedUser(e.value)
                            }}
                            options={users?.map((item, idx) => ({
                                value: item?.id,
                                label: item?.fullName
                            }))}
                        />
                        <Button disabled={!selectedUser} onClick={()=>{
                            setSelectedUser(null)
                            getOrders(null)
                        }} style={{marginLeft:10}} shape="circle" icon={<CloseOutlined />} />
                        </>
                    )}
                

                </div>
            </div>
            <Spin spinning={loading} tip="Duke procesuar te dhenat..."><Table dataSource={orders} size="small" columns={columns} style={{ marginTop: 20 }} onRow={(record) => ({
                onClick: () => {
                    handleRowClick(record);
                },
            })} /></Spin>

        </div>
    )
}

export default Orders;